import React from 'react';
import {Button, Card, Col, Form, Icon, Input, message, Modal, Popover, Row, Select,Tooltip,Switch} from 'antd';
import {fetchEvt} from "../../redux/actions/evt";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {inEditMode} from "../../redux/actions/global";
import {updateEventPosters} from "../../services/evt";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import QRCode from "../../components/qr-code/QRCode";
import Logo2 from "../../style/imgs/logo2.png"
import canvasToImage from 'canvas-to-image';
import {disableCheckinpoint, enableCheckinpoint} from "../../services/checkinpoint";
import classnames from "classnames";
import moment from 'moment';
import CkUpload from "../../components/CkUpload";
import {batchConfigureIbeacon, findUserIbeacons,findIbeacons} from "../../services/ibeaconConfig";
import styled from "styled-components";
import config from '../../utils/config'
import EvtViewCheckinpointDes from "./EvtViewCheckinpointDes";
import EvtViewCheckinpointPeriodicTime from "./EvtViewCheckinpointPeriodicTime";
import EvtViewCheckinpointSubAccount from "./EvtViewCheckinpointSubAccount";
import EvtViewCheckinpointTickets from "./EvtViewCheckinpointTickets";
import PurchaseServiceTips from "../PurchaseServiceTips";
import {isValidity} from "../../services/global";
import Iconfont from "../../components/Iconfont/Iconfont";
import {mobile_url_domin} from "../../utils/config";

const mapStateToPorps = state => {
    const cmEnums = state.cmEnums;
    return {cmEnums};
};
const mapDispatchToProps = dispatch => ({
    fetchEvt: bindActionCreators(fetchEvt, dispatch),
});



const IbeanconOptionContent = styled.div`
  display: flex;
  min-width: 430px;
  .ibeancons-icon{
    img{
      width: 60px;
      height: 60px;
    }
    margin-right: 7px;
  }
  .ibeancons-configured-desc{
      color: #999;
      font-size: 12px;
  }
  .ibeancons-id{
  
  }
  .ibeancons-configured-status{
    .used-status{
        color: #f5222d;
    }
    .noused-status{
       color: #52c41a
    }
  }

`

const IbeanconSelect = styled(Select)`
  .ant-select-selection__choice__content .ibeancons-icon{
    img{
      width: 24px;
      height: 24px;
    }
  }
`

class EvtViewCheckinpointQrcodeForm extends React.Component {
    constructor(props) {
        super(props);
        this.mounted = false;
        this.pstView =null;
        this.state = {
            isMember:'SENIORMEMBER',
            validity:false,
            validityCheckinTiming:false,
            editCheckinpointVisible:false,
            editCheckinpointTimeVisible:false,
            editCheckinpointSubAccVisible:false,
            editCheckinpointTicketVisible:false,
            checkinpointDes:null,
            qrcodeSize:[{px:258,side:8,dis:0.5},{px:344,side:12,dis:0.8},{px:430,side:15,dis:1.0},{px:860,side:30,dis:1.5},{px:1280,side:50,dis:2.5}],
            qrcodeModal:{
                title:null,
                refName:null,
                value:null
            },
            qrcodeDownload:false,
            formLoading: false,
            ibeanconConfigModalVisible: false,
            viewCheckinpoint: null,
            viewCheckinpointBoundIbeacons: null,
            ibeancons: [],
        }
    }


    componentDidMount() {
        this.mounted = true;
        isValidity('SUBACCOUNT', (vaild) => {
            this.setState({
                validity:vaild
            })
        })
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    save = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                this.changeFormLoading(true);
                const that = this;
                batchConfigureIbeacon(Object.assign({checkinpointId: this.state.viewCheckinpoint.id}, values)).then(res => {
                    if (res.code == 200) {
                        message.info("配置成功!");
                        that.props.editableChange(this.props.editableStatePropName, false, true)
                    } else {
                        message.error(res.msg,6);
                    }
                }).catch(err => {
                    message.warn("访问异常");
                }).finally(() => {
                    that.changeFormLoading(false)
                })
            } else {
                console.log('error', error, values);
            }
        });
    }

    changeFormLoading = (loading) => {
        if (this.mounted) {
            this.setState({
                formLoading: loading,
            })
        }
    }

    handleCancel = () => {
        this.changeFormLoading(false);
        this.setState({
            ibeanconConfigModalVisible: false,
            viewCheckinpointBoundIbeacons: null,
            viewCheckinpoint: null,
        })
        this.props.editableChange(this.props.editableStatePropName, false)
    }

    downloadQR = (QRRef, fileName) => {
        canvasToImage(QRRef, {
            name: fileName,
            type: 'png',
            quality: 1
        });
    }

    showQrcodeDownload = (obj,index)=>{
        const {evt} = this.props;
        let _obj={
            title:`签到二维码（${obj.name}）`,
            refName:`checkinpoint-qr-canvas${index}`,
            value:`${mobile_url_domin}/mobile/checkin?eventId=${evt.header.id}&checkinPointId=${obj.id}&hostUserId=${localStorage.getItem('userId')}`
        };
        this.setState({
            qrcodeModal:_obj,
        },()=>{
            this.setState({
                qrcodeDownload:true,
            })
        })
    }
    handQrcodeDownload = ()=>{
        this.setState({
            qrcodeDownload:false,
        })
    }

    showCheckinpointModal = (record)=>{
        this.setState({
            checkinpointDes:record,
        },()=>this.setState({editCheckinpointVisible:true}))
    }
    showCheckinpointTimeModal = (record)=>{
        this.setState({
            checkinpointDes:record,
        },()=>this.setState({editCheckinpointTimeVisible:true}))
    }
    showCheckinpointSubAccModal = (record)=>{
        this.setState({
            checkinpointDes:record,
        },()=>this.setState({editCheckinpointSubAccVisible:true}))
    }
    showCheckinpointTicketModal = (record)=>{
        this.setState({
            checkinpointDes:record,
        },()=>this.setState({editCheckinpointTicketVisible:true}))
    }
    hideCheckinpointModal = ()=>{
        this.setState({editCheckinpointVisible:false})
    }
    hideCheckinpointTimeModal = ()=>{
        this.setState({editCheckinpointTimeVisible:false})
    }
    hideCheckinpointSubAccModal = ()=>{
        this.setState({editCheckinpointSubAccVisible:false})
    }
    hideCheckinpointTicketModal = ()=>{
        this.setState({editCheckinpointTicketVisible:false})
    }

    render() {
        const evt = this.props.evt;

        console.log(" this.props.evt", this.props.evt);

        const {getFieldDecorator, getFieldValue, getFieldError} = this.props.form;

        const formItemLayout = {
            labelCol: {
                xs: {span: 6},
                sm: {span: 6},
            },
            wrapperCol: {
                xs: {span: 18},
                sm: {span: 18},
            },
        };

        return (
            <div>
                <Row gutter={16} className="checkinpoint-comp">
                    {evt.checkinpoints.map((checkinpoint, index) => {

                        const ckpBeginTime = checkinpoint.beginTime ? moment(checkinpoint.beginTime, "YYYY-MM-DD HH:mm:ss") : null;
                        const ckpEndTime = checkinpoint.endTime ? moment(checkinpoint.endTime, "YYYY-MM-DD HH:mm:ss") : null;

                        const qrcode = <QRCode
                            value={`${mobile_url_domin}/mobile/checkin?eventId=${evt.header.id}&checkinPointId=${checkinpoint.id}&hostUserId=${localStorage.getItem('userId')}`}
                            size={100}
                            logoWidth={33}
                            logoHeight={33}
                            refName={`checkinpoint-qr-canvas${index}`}
                            logo={evt.header.customQrcodeLogo ? evt.header.customQrcodeLogo : "https://img.qdj8.cn/4db620938b1bbe99aff190c611092df9f63e0e89.jpg"}/>


                        const boundIbeacons = checkinpoint.boundIbeacons && checkinpoint.boundIbeacons.length > 0 ? checkinpoint.boundIbeacons : null;

                        return (
                            <Col span={24} className='checkinpoint-item' key={`checkinpoint-qr-${index}`}>
                                <Card
                                    bordered={false}
                                    title={
                                        <div>
                                            <div className="checkinpoint-qrcode-tl">
                                                {/*<Popover*/}
                                                    {/*overlayClassName={checkinpoint.active ? "checkinpoint-enable" : "checkinpoint-disable"}*/}
                                                    {/*placement="left"*/}
                                                    {/*content={*/}
                                                        {/*<a style={{fontSize: 14}} onClick={() => {*/}
                                                            {/*const reqFun = checkinpoint.active ? disableCheckinpoint : enableCheckinpoint;*/}
                                                            {/*reqFun({*/}
                                                                {/*id: checkinpoint.id,*/}
                                                                {/*eventId: evt.header.id*/}
                                                            {/*}).then(res => {*/}
                                                                {/*if (res.code == 200) {*/}
                                                                    {/*message.info((checkinpoint.active ? "关闭" : "开启") + "签到点成功!");*/}
                                                                    {/*//this.props.inEditMode(false, this.state.tabsActiveKey)*/}
                                                                    {/*this.props.editableChange(this.props.editableStatePropName, false, true)*/}
                                                                {/*} else {*/}
                                                                    {/*message.error(res.msg,6);*/}
                                                                {/*}*/}
                                                            {/*}).catch(err => {*/}
                                                                {/*message.warn("访问异常");*/}
                                                            {/*})*/}
                                                        {/*}}>*/}
                                                            {/*<Icon*/}
                                                                {/*type={checkinpoint.active ? "pause-circle-o" : "play-circle-o"}/>*/}
                                                            {/*{*/}
                                                                {/*checkinpoint.active ? " 关闭" : " 开启"*/}
                                                            {/*}*/}
                                                        {/*</a>*/}
                                                    {/*}*/}
                                                    {/*trigger="click">*/}
                                                    {/*<span style={{fontSize: "12px", cursor: "pointer"}}*/}
                                                          {/*className="checkinpoint-qrcode-open-or-close-btn">*/}
                                                        {/*{*/}
                                                            {/*checkinpoint.active ? "签到点开启中" : "签到点已关闭"*/}
                                                        {/*}*/}
                                                    {/*</span>*/}
                                                {/*</Popover>*/}

                                                <Switch checkedChildren="开"
                                                        unCheckedChildren="关"
                                                        onChange={(e) => {
                                                            const reqFun = checkinpoint.active ? disableCheckinpoint : enableCheckinpoint;
                                                            reqFun({
                                                                id: checkinpoint.id,
                                                                eventId: evt.header.id
                                                            }).then(res => {
                                                                if (res.code == 200) {
                                                                    message.info((checkinpoint.active ? "关闭" : "开启") + "签到点成功!");
                                                                    //this.props.inEditMode(false, this.state.tabsActiveKey)
                                                                    this.props.editableChange(this.props.editableStatePropName, false, true)
                                                                } else {
                                                                    message.error(res.msg,6);
                                                                }
                                                            }).catch(err => {
                                                                message.warn("访问异常");
                                                            })
                                                        }}
                                                        checked={checkinpoint.active} />


                                            </div>
                                            <div className="checkinpoint-qrcode-ckname">{checkinpoint.name}<span style={{color:'#959595'}}>{checkinpoint.enableCheckinTiming && '（周期性签到）'}</span></div>


                                            <div className="checkinpoint-qrcode-2row">
                                                <div className="checkinpoint-qrcode-time">
                                                    {
                                                        ckpBeginTime || ckpEndTime ?
                                                            `${ckpBeginTime ? ckpBeginTime.format("YYYY-MM-DD HH:mm:ss") : '不限签到开始日期'} ~ ${ckpEndTime ? ckpEndTime.format("YYYY-MM-DD HH:mm:ss") : '不限签到结束日期'}`
                                                            :
                                                            "不限制签到日期"
                                                    }

                                                </div>
                                                {/*<div className="checkinpoint-qrcode-ckcount">*/}
                                                    {/*{checkinpoint.address && <span className='ckname-address'>*/}
                                                        {/*<Tooltip overlayClassName='overlay-image' mouseEnterDelay={0.3} title={*/}
                                                            {/*<span>{checkinpoint.address}</span>*/}
                                                        {/*}>*/}
                                                            {/*<span>{checkinpoint.address}</span>*/}
                                                    {/*</Tooltip>*/}
                                                        {/*</span>}*/}
                                                    {/*<a className='ckname-addressicon' href="#" onClick={()=>{*/}
                                                            {/*this.showCheckinpointModal(checkinpoint);*/}
                                                    {/*}}>*/}
                                                        {/*<Icon style={{fontSize:16}} type={'environment'}/>*/}
                                                        {/*<span>定位</span>*/}
                                                        {/*<Tooltip  mouseEnterDelay={0.3} title={*/}
                                                            {/*<div>*/}
                                                                {/*<p>签到点可以开启定位签到，范围在设置地址（约500米内）。</p>*/}
                                                                {/*<p>重要提示：开启定位后，如果参与人签到时定位失败或不在指定范围内，将无法签到。</p>*/}
                                                            {/*</div>*/}


                                                        {/*}>*/}
                                                            {/*<span title="" style={{marginLeft: "3px"}}><Icon style={{color:'#434343'}} type="question-circle-o"/></span>*/}
                                                        {/*</Tooltip>*/}
                                                    {/*</a></div>*/}
                                            </div>

                                        </div>
                                    }
                                    className={classnames("qrcode-card", "checkinpoint-qrcode-card", {"checkinpoint-inactive": !checkinpoint.active})}>
                                    <div className="qrcode-card-contain">
                                        <div className="qrcode-card-des">
                                            {/*<div>参与者可通过扫描此二维码签到</div>*/}

                                            <div className="qrcode-tools">
                                                {/*<div className="qtd">*/}
                                                    {/*<div className="qtd-title">*/}
                                                        {/*(PC)扫码设备签到<Tooltip placement="bottom" overlayClassName='overlay-image' mouseEnterDelay={0.3} title={*/}
                                                        {/*<div style={{maxHeight:700,overflow:'auto'}}>*/}
                                                            {/*<a href="https://www.bilibili.com/video/av22639586/?spm_id_from=333.23.home_video_list.1" target="_Blank">视频演示</a>*/}
                                                        {/*</div>*/}
                                                    {/*}><span title="" style={{marginLeft: "3px"}}><Icon type="question-circle-o"/></span>*/}
                                                    {/*</Tooltip>：*/}
                                                    {/*</div>*/}
                                                    {/*<div className="qtd-content">*/}
                                                        {/*<a href={`/evt/${evt.header.id}/checkpoint/${checkinpoint.id}/organizer-scan-checkin`}*/}
                                                           {/*target="_blank">启动</a>*/}
                                                    {/*</div>*/}
                                                {/*</div>*/}
                                                {/*<div className="qtd">*/}
                                                    {/*<div className="qtd-title">*/}
                                                        {/*参与人iPad签到<Tooltip placement="bottom" overlayClassName='overlay-image' mouseEnterDelay={0.3} title={*/}
                                                        {/*<div>*/}
                                                            {/*复制该链接，在iPad或者其他电子屏打开即可使用。*/}
                                                        {/*</div>*/}
                                                    {/*}><span title="" style={{marginLeft: "3px"}}><Icon type="question-circle-o"/></span>*/}
                                                    {/*</Tooltip>：*/}
                                                    {/*</div>*/}
                                                    {/*<div className="qtd-content">*/}
                                                        {/*<a href={`/evt/${evt.header.id}/checkpoint/${checkinpoint.id}/attendee-scan-checkin`}*/}
                                                           {/*target="_blank">启动</a>*/}
                                                    {/*</div>*/}
                                                {/*</div>*/}
                                                {/*<div className="qtd">*/}
                                                    {/*<div className="qtd-title">*/}
                                                        {/*重复签到间隔*/}
                                                        {/*<Tooltip placement="bottom" overlayClassName='overlay-image' mouseEnterDelay={0.3} title={*/}
                                                            {/*<div>*/}
                                                               {/*同一个参与人重复签到的时间间隔（如：配置一天只能签到一次），在周期性签到中一起设置。<a href="https://www.yuque.com/odh2xi/manual/rdi3faeuc977n8vu#TFzxW" target="_Blank">  详细帮助</a>*/}
                                                            {/*</div>*/}
                                                        {/*}><span title="" style={{marginLeft: "3px"}}><Icon type="question-circle-o"/></span>*/}
                                                        {/*</Tooltip>*/}
                                                        {/*：*/}
                                                    {/*</div>*/}
                                                    {/*<div className="qtd-content">*/}
                                                        {/*{checkinpoint.nextCheckinTime} {this.props.cmEnums.data.NextCheckinTimeUnit[checkinpoint.nextCheckinTimeUnit.toString()].enumDesc}*/}
                                                    {/*</div>*/}
                                                {/*</div>*/}
                                                <div className="qtd">
                                                    <div className="qtd-title">
                                                        高级签到设置
                                                        <Tooltip placement="bottom" overlayClassName='overlay-image' mouseEnterDelay={0.3} title={
                                                            <div>
                                                                详细配置签到时间段，时间间隔，适用于签到和签退，周期性考勤，控制签到次数等。<a href="https://www.yuque.com/odh2xi/manual/rdi3faeuc977n8vu#TFzxW" target="_Blank">  详细帮助</a>
                                                            </div>
                                                        }><span title="" style={{marginLeft: "3px"}}><Icon type="question-circle-o"/></span>
                                                        </Tooltip>：
                                                    </div>
                                                    <div className="qtd-content">
                                                        <a className={checkinpoint.enableCheckinTiming ? 'qtd-success' : 'qtd-error'} onClick={()=>{
                                                               this.showCheckinpointTimeModal(checkinpoint);
                                                        }}>{checkinpoint.enableCheckinTiming ? '已开启' : '去设置'}</a>
                                                        <span style={{color:'#959595'}}>（间隔{checkinpoint.nextCheckinTime}{this.props.cmEnums.data.NextCheckinTimeUnit[checkinpoint.nextCheckinTimeUnit.toString()].enumDesc}）</span>
                                                    </div>
                                                </div>
                                                <div className="qtd">
                                                    <div className="qtd-title">
                                                        GPS定位
                                                        <Tooltip placement="bottom" overlayClassName='overlay-image' mouseEnterDelay={0.3} title={
                                                            <div>
                                                                <p>签到点可以开启定位签到，范围在设置地址（20-2000米）。</p>
                                                                <p>重要提示：</p>
                                                                <p>1，开启定位后，如果部分参与人无法签到成功，原因是：这部分手机GPS定位功能未开启（或室内GPS定位不准）</p>
                                                                <p>1，开启定位后，如果全部参与人都无法签到成功，请检查您定位的地点（地图蓝色小点GPS是否准确和设置的范围是否太小）</p>
                                                            </div>
                                                        }><span title="" style={{marginLeft: "3px"}}><Icon type="question-circle-o"/></span>
                                                        </Tooltip>：
                                                    </div>
                                                    <div className="qtd-content">
                                                        <a className={checkinpoint.address ? 'qtd-success' : 'qtd-error'} onClick={()=>{
                                                            this.showCheckinpointModal(checkinpoint);
                                                        }}>{checkinpoint.address ? '已开启' : '未开启'}</a>
                                                    </div>
                                                </div>
                                                {/* <div className="qtd" style={{marginBottom: "5px"}}>
                                                    <div className="qtd-title">
                                                        微信摇一摇<Tooltip placement="bottom" overlayClassName='overlay-image' mouseEnterDelay={0.3} title={
                                                        <div style={{maxHeight:700,overflow:'auto'}}>
                                                            <a href="http://v.youku.com/v_show/id_XMTg1MTg3MDUwNA==.html?spm=a2hzp.8244740.userfeed.5!2~5~5~5!3~5~A&qq-pf-to=pcqq.group" target="_Blank">视频演示</a>
                                                        </div>
                                                    }>
                                                        <span title="" style={{marginLeft: "3px"}}><Icon type="question-circle-o"/></span>
                                                    </Tooltip>：
                                                    </div>
                                                    <div className="qtd-content">
                                                        <a className={boundIbeacons ? 'qtd-success' : 'qtd-error'} href="#" onClick={() => {

                                                            const that = this;
                                                            findIbeacons(Object.assign({
                                                                eventId:evt.header.id,
                                                                pageSize: "1000"
                                                            })).then(res => {
                                                                if (res.code == 200) {
                                                                    this.setState({
                                                                        ibeanconConfigModalVisible: true,
                                                                        ibeancons: res.data,
                                                                        viewCheckinpoint: checkinpoint,
                                                                        viewCheckinpointBoundIbeacons: boundIbeacons,
                                                                    })
                                                                } else {
                                                                    message.error(res.msg,6);
                                                                }
                                                            }).catch(err => {
                                                                message.warn("访问异常");
                                                            }).finally(() => {
                                                                that.changeFormLoading(false)
                                                            })


                                                        }}>

                                                            {
                                                                boundIbeacons ? "已配置" : "未配置"
                                                            }
                                                        </a>
                                                    </div>
                                                </div> */}
                                                <div className="qtd">
                                                    <div className="qtd-title">
                                                        授权给子账号
                                                        <Tooltip placement="bottom" overlayClassName='overlay-image' mouseEnterDelay={0.3} title={
                                                            <div>
                                                                把活动的该签到点权限，分配子账号（签到员）管理；可在个人中心-子账号管理，控制是否可以导出数据。<a href="https://www.yuque.com/odh2xi/manual/rdi3faeuc977n8vu#blcIr" target="_Blank">  详细帮助</a>
                                                            </div>
                                                        }><span title="" style={{marginLeft: "3px"}}><Icon type="question-circle-o"/></span>
                                                        </Tooltip>：
                                                    </div>
                                                    <div className="qtd-content">
                                                        <a onClick={()=>{
                                                            this.state.validity ? this.showCheckinpointSubAccModal(checkinpoint) : this.pstView.show()
                                                        }}>管理</a>
                                                    </div>
                                                </div>
                                                <div className="qtd">
                                                    <div className="qtd-title">
                                                        可签到票种
                                                        <Tooltip placement="bottom" overlayClassName='overlay-image' mouseEnterDelay={0.3} title={
                                                            <div>
                                                                指定该签到点允许签到的票种，默认是全部。<a href="https://www.yuque.com/odh2xi/manual/rdi3faeuc977n8vu#oPeAk" target="_Blank">  详细帮助</a>
                                                            </div>
                                                        }><span title="" style={{marginLeft: "3px"}}><Icon type="question-circle-o"/></span>
                                                        </Tooltip>：
                                                    </div>
                                                    <div className="qtd-content">
                                                        <a onClick={()=>{
                                                            this.state.validity ? this.showCheckinpointTicketModal(checkinpoint) : this.pstView.show()
                                                        }}>管理</a>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div style={{borderTop:'1px solid #ddd',marginTop:20,padding:'20px 0 5px 0'}}>
                                        <Button disabled={!checkinpoint.active} size={'large'}
                                                onClick={() => {
                                                    window.open(`/evt/${evt.header.id}/checkpoint/${checkinpoint.id}/organizer-scan-checkin`);
                                                }}
                                                style={{marginRight:12}}
                                                type="primary" ghost><Iconfont style={{fontWeight:700}} libname="ckicon" type={'saomaqiang'}/>扫码枪签到</Button>
                                        <Button style={{marginRight:12}} disabled={!checkinpoint.active} size={'large'}
                                                onClick={()=>window.open(`/evt/${evt.header.id}/checkpoint/${checkinpoint.id}/face-scan-checkin`)}
                                                type="primary" ghost><Iconfont libname="ckicon" type={'renlianshibie'}/>人脸识别</Button>
                                        <Button disabled={!checkinpoint.active} size={'large'}
                                                onClick={()=>window.open(`/evt/${evt.header.id}/checkpoint/${checkinpoint.id}/attendee-scan-checkin`)}
                                                style={{marginRight:12}}
                                                type="primary" ghost><Iconfont libname="ckicon" type={'qiandao2'}/>输入签到</Button>
                                        <Button disabled={!checkinpoint.active} size={'large'}
                                                onClick={()=>window.open(`/admin/evtm/writecheckin`)}
                                                style={{marginRight:12}}
                                                type="primary" ghost><Iconfont libname="ckicon" type={'qiandao4'}/>手写签到</Button>

                                    </div>
                                </Card>
                            </Col>
                        )
                    })}
                </Row>


                {
                    this.state.ibeanconConfigModalVisible ?
                        <Modal
                            visible={true}
                            title={`微信摇一摇Ibeacon配置--${this.state.viewCheckinpoint.name}`}
                            width="750px"
                            maskClosable={false}
                            onCancel={this.handleCancel}
                            footer={[
                                <Button key="back" onClick={this.handleCancel}>
                                    放弃
                                </Button>,
                                <Button key="submit" type="primary" loading={this.state.formLoading} onClick={this.save}>
                                    保存
                                </Button>,
                            ]}
                        >
                            <Form.Item
                                {...formItemLayout}
                                label={(
                                    <span>
                                        摇一摇设备
                                    </span>
                                )}
                            >

                                {getFieldDecorator('ids', {
                                    initialValue: this.state.viewCheckinpointBoundIbeacons && this.state.viewCheckinpointBoundIbeacons.length > 0 ? this.state.viewCheckinpointBoundIbeacons.map(ib => ib.id) : [],
                                    rules: [
                                        {required: true, message: '设备为必填项'}
                                    ]
                                })(
                                    <IbeanconSelect mode="multiple" style={{width: "450px"}}>
                                        {
                                            this.state.ibeancons ? this.state.ibeancons.map((f, findex) => {

                                                    const used = f.configured && f.checkinpointId != this.state.viewCheckinpoint.id;

                                                    return <Select.Option key={`ooyp6343f3c${findex}`}
                                                                          value={`${f.id}`}>
                                                        <IbeanconOptionContent>
                                                            <div className="ibeancons-icon">
                                                                <img src={f.iconUrl}/>
                                                            </div>
                                                            <div className="ibeancons-contain">
                                                                <div className="ibeancons-id">
                                                                    <span>{f.deviceId}</span>
                                                                </div>

                                                                {
                                                                    f.configured ?
                                                                        <div className="ibeancons-configured-desc">
                                                                            『{f.event ? f.event.name : ''}』{f.checkinpoint ? f.checkinpoint.name : ''}
                                                                        </div> :
                                                                        null
                                                                }
                                                                <div className="ibeancons-configured-status">
                                                                    <span className={used ? "used-status" : "noused-status"}>
                                                                        {
                                                                            used ? "已被其他签到点使用" : "可用"
                                                                        }
                                                                    </span>
                                                                </div>

                                                            </div>
                                                        </IbeanconOptionContent>

                                                    </Select.Option>

                                                })
                                                :
                                                null
                                        }

                                    </IbeanconSelect>
                                )}
                            </Form.Item>
                            <Form.Item
                                {...formItemLayout}
                                label={(
                                    <span>
                                        图标
                                    </span>
                                )}
                                extra="必须上传宽高比为1:1的图片(如:100x100)，最大200x200像素!"
                            >

                                {getFieldDecorator('iconUrl', {
                                    initialValue: this.state.viewCheckinpointBoundIbeacons ? this.state.viewCheckinpointBoundIbeacons[0].iconUrl : "http://shp.qpic.cn/wx_shake_bus/0/15323125812e8cb9ac1091da1812f9a17ac392711c/120",
                                    rules: [
                                        {required: true, message: '图标必须选择'}
                                    ],
                                    getValueFromEvent: (fileUrlObj) => {
                                        return fileUrlObj.url;
                                    }
                                })(
                                    <CkUpload
                                        action={config.api.ibeaconMaterialUpload}
                                        width={100}
                                        height={100}
                                    />
                                )}
                            </Form.Item>
                            <Form.Item
                                {...formItemLayout}
                                label={(
                                    <span>
                                        标题
                                    </span>
                                )}
                            >

                                {getFieldDecorator('title', {
                                    initialValue: this.state.viewCheckinpointBoundIbeacons ? this.state.viewCheckinpointBoundIbeacons[0].title : "",
                                    rules: [
                                        {required: true, message: '标题为必填项'},
                                        {
                                            pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]{2,12}$/,
                                            message: '格式为中英文加下划线,长度限制为2至12个之间,中文算2个!',
                                            transform: (value) => value.replace(/([\u4e00-\u9fa5]+?)/g, 'aa')
                                        }
                                    ]
                                })(
                                    <Input/>
                                )}
                            </Form.Item>

                            <Form.Item
                                {...formItemLayout}
                                label={(
                                    <span>
                                        副标题
                                    </span>
                                )}
                            >

                                {getFieldDecorator('subTitle', {
                                    initialValue: this.state.viewCheckinpointBoundIbeacons ? this.state.viewCheckinpointBoundIbeacons[0].subTitle : "",
                                    rules: [
                                        {required: true, message: '副标题为必填项'},
                                        {
                                            pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9]{2,14}$/,
                                            message: '格式为中英文加下划线,长度限制为2至14个之间,中文算2个!',
                                            transform: (value) => value.replace(/([\u4e00-\u9fa5]+?)/g, 'aa')
                                        }
                                    ]
                                })(
                                    <Input/>
                                )}
                            </Form.Item>
                        </Modal>
                        :
                        null
                }

                <Modal
                    visible={this.state.qrcodeDownload}
                    title={<div>
                        {this.state.qrcodeModal.title}
                        <p style={{fontSize:12,color:'#959595'}}>若无法下载，请使用最新版谷歌Chrome浏览器</p>
                    </div>}
                    // width="650px"
                    maskClosable={false}
                    onCancel={this.handQrcodeDownload}
                    footer={null}
                >
                    <div>
                        {this.state.qrcodeDownload ? this.state.qrcodeSize.map((obj,index)=>{
                            return <div key={index} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'5px 30px'}}>
                                <div>
                                    <div style={{display:'none'}}>
                                        <QRCode
                                            value={this.state.qrcodeModal.value}
                                            size={obj.px}
                                            refName={`${this.state.qrcodeModal.refName}${index}`}
                                            logoWidth={obj.px/6}
                                            logoHeight={obj.px/6}
                                            logo={evt.header.customQrcodeLogo ? evt.header.customQrcodeLogo : Logo2}/>
                                    </div>
                                    <div style={{width:82,textAlign:'center'}}>
                                        <Icon type='qrcode' style={{fontSize:40}}/>
                                        <div style={{fontSize:12,color:'#999'}}>{obj.px}x{obj.px}像素</div>
                                    </div>
                                </div>
                                <div>边长{obj.side}cm</div>
                                <div>扫码距离{obj.dis}m</div>
                                <a href="#" onClick={this.downloadQR.bind(this, `${this.state.qrcodeModal.refName}${index}`, `[${evt.header.name}]-${this.state.qrcodeModal.title}_${obj.px}`)}>下载</a>
                            </div>
                        }) : ''}
                    </div>

                </Modal>

                {this.state.editCheckinpointVisible &&
                <EvtViewCheckinpointDes
                    visible={this.state.editCheckinpointVisible}
                    data={this.state.checkinpointDes}
                    hide={this.hideCheckinpointModal}
                    editableStatePropName={this.props.editableStatePropName}
                    editableChange={this.props.editableChange}
                />
                }
               {this.state.editCheckinpointTimeVisible &&
               <EvtViewCheckinpointPeriodicTime
                    visible={this.state.editCheckinpointTimeVisible}
                    data={this.state.checkinpointDes}
                    hide={this.hideCheckinpointTimeModal}
                    editableStatePropName={this.props.editableStatePropName}
                    editableChange={this.props.editableChange}
                />}
               {this.state.editCheckinpointSubAccVisible &&
               <EvtViewCheckinpointSubAccount
                    visible={this.state.editCheckinpointSubAccVisible}
                    data={this.state.checkinpointDes}
                    hide={this.hideCheckinpointSubAccModal}
                    editableStatePropName={this.props.editableStatePropName}
                    editableChange={this.props.editableChange}
                />}
                {this.state.editCheckinpointTicketVisible &&
               <EvtViewCheckinpointTickets
                    evt={evt}
                    visible={this.state.editCheckinpointTicketVisible}
                    data={this.state.checkinpointDes}
                    hide={this.hideCheckinpointTicketModal}
                    editableStatePropName={this.props.editableStatePropName}
                    editableChange={this.props.editableChange}
                />}

                <PurchaseServiceTips
                    ref={(pst) => {
                        this.pstView = pst
                    }}
                    member={'SENIORMEMBER'}

                />
            </div>
        )
    }
}


EvtViewCheckinpointQrcodeForm.contextTypes = {}

EvtViewCheckinpointQrcodeForm.defaultProps = {
    evt: {},
    editable: false,
    editableStatePropName: "checkinpointQrcodeEditable",
    editableChange: (editable, dataChanged = false) => null,
}

EvtViewCheckinpointQrcodeForm.propTypes = {}


export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(EvtViewCheckinpointQrcodeForm));



// WEBPACK FOOTER //
// ./src/containers/evt/EvtViewCheckinpointQrcodeForm.jsx